/* eslint-disable */
import moment from 'moment';
import { isEqual, cloneDeep } from 'lodash';
import history from '../../containers/History';

import {
  getDataSource,
  getMe,
  getPhysiciansAndEkgStackCount,
  getOrderingProvider,
  getInterpretations,
  getQtEkgReviewStack,
  postEkgsEmailExport,
  openModal,
  closeModal,
} from '../../store/appReducer';
import {
  DATASOURCES,
  CONFIRMED,
  PHYSICIAN,
  TRIAGE,
  TRIAGE_OPTION,
  KPSP_PRACTICE_INBOX,
  ALL_PATIENTS_OPTION,
  KARDIA_PRO_START_DATE,
  SORT_TYPES,
  EKG_TABLE_COLUMN_HEADERS,
  ALL_PHYSICIANS_OPTION,
  MAX_BPM_VALUE,
  MIN_BPM_VALUE,
  MAX_QTCF_VALUE,
  MIN_QTCF_VALUE,
  EKG_REVIEW_PAGE_TABS,
  ROUTES,
  CONFIRMED_OPTION,
  TABLE_BULK_ACTIONS,
  CLEAR_STATE,
} from '../../constants';
import {
  sortEkgRecordingIds,
  filterEkgRecordingIds,
} from '../../containers/Tables/EkgTable/Utilities';
import {
  getNextSortDirection,
  getSelectedList,
} from '../../containers/Tables/Utilities';
import { handleOnNavClick as handleOnEkgRecordingNavClick } from '../../pages/EkgReviewEkgRecording/module';
import { checkServiceProviderFeatureEnabled } from 'configs'


// ------------------------------------
// Constants
// ------------------------------------

const PREFIX = 'QtEkgReview.'
export const UPDATE_BULK_ACTION_IS_FETCHING = `${PREFIX}UPDATE_BULK_ACTION_IS_FETCHING`
export const UPDATE_BULK_ACTION_COMPLETE = `${PREFIX}UPDATE_BULK_ACTION_COMPLETE`
export const UPDATE_BULK_ACTION_SUCCESS_MESSAGE = `${PREFIX}UPDATE_BULK_ACTION_SUCCESS_MESSAGE`
export const UPDATE_REFRESH_CLICKED = `${PREFIX}UPDATE_REFRESH_CLICKED`
export const UPDATE_SELECTED_PAGE_TAB = `${PREFIX}UPDATE_SELECTED_PAGE_TAB`
export const UPDATE_SELECTED_INDEX = `${PREFIX}UPDATE_SELECTED_INDEX`
export const UPDATE_SELECTED_INBOX_ID = `${PREFIX}UPDATE_SELECTED_INBOX_ID`
export const UPDATE_SELECTED_PATIENT_ID = `${PREFIX}UPDATE_SELECTED_PATIENT_ID`
export const UPDATE_SELECTED_PHYSICIAN_ID = `${PREFIX}UPDATE_SELECTED_PHYSICIAN_ID`
export const UPDATE_SELECTED_PHYSICIANS = `${PREFIX}UPDATE_SELECTED_PHYSICIANS`
export const UPDATE_SELECTED_ASSIGNED_PHYSICIANS = `${PREFIX}UPDATE_SELECTED_ASSIGNED_PHYSICIANS`;
export const UPDATE_SELECTED_QT_ORDERING_PRACTICE = `${PREFIX}UPDATE_SELECTED_QT_ORDERING_PRACTICE`;
export const UPDATE_SELECTED_EKG_RESULT = `${PREFIX}UPDATE_SELECTED_EKG_RESULT`
export const UPDATE_SELECTED_DATES = `${PREFIX}UPDATE_SELECTED_DATES`
export const UPDATE_SELECTED_BPM_VALUES = `${PREFIX}UPDATE_SELECTED_BPM_VALUES`
export const UPDATE_SELECTED_QTCF_VALUES = `${PREFIX}UPDATE_SELECTED_QTCF_VALUES`
export const UPDATE_SELECTED_INTR_COMMENT = `${PREFIX}UPDATE_SELECTED_INTR_COMMENT`
export const UPDATE_SELECTED_PATIENT_TEXT = `${PREFIX}UPDATE_SELECTED_PATIENT_TEXT`;
export const UPDATE_SELECTED_CONFIRMED_CURRENT_MONTH = `${PREFIX}UPDATE_SELECTED_CONFIRMED_CURRENT_MONTH`
export const UPDATE_SELECTED_EKGS = `${PREFIX}UPDATE_SELECTED_EKGS`
export const RESET_FILTERS = `${PREFIX}RESET_FILTERS`
export const UPDATE_SORTS = `${PREFIX}UPDATE_SORTS`
export const RESET_SORTS = `${PREFIX}RESET_SORTS`
export const UPDATE_SELECTED_POPOVER = `${PREFIX}UPDATE_SELECTED_POPOVER`
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`
export const UPDATE_STACK_NEXT_TOKEN = `${PREFIX}EKG_STACK_NEXT_TOKEN`

// ------------------------------------
// Actions
// ------------------------------------
export const updateBulkActionIsFetching = flag => ({
  type: UPDATE_BULK_ACTION_IS_FETCHING,
  payload: flag,
});
export const updateBulkActionComplete = flag => ({
  type: UPDATE_BULK_ACTION_COMPLETE,
  payload: flag,
});
export const updateBulkActionSuccessMessage = msg => ({
  type: UPDATE_BULK_ACTION_SUCCESS_MESSAGE,
  payload: msg,
});
export const updateRefreshClicked = clicked => ({
  type: UPDATE_REFRESH_CLICKED,
  payload: clicked,
});
export const updateSelectedPageTab = tab => ({
  type: UPDATE_SELECTED_PAGE_TAB,
  payload: tab,
});

export const updateSelectedIndex = index => ({
  type: UPDATE_SELECTED_INDEX,
  payload: index,
});
export const updateSelectedInboxId = id => ({
  type: UPDATE_SELECTED_INBOX_ID,
  payload: id,
});

export const updateSelectedPatientId = id => ({
  type: UPDATE_SELECTED_PATIENT_ID,
  payload: id,
});
export const updateSelectedPhysicianId = id => ({
  type: UPDATE_SELECTED_PHYSICIAN_ID,
  payload: id,
});
export const updateSelectedPhysicians = id => ({
  type: UPDATE_SELECTED_PHYSICIANS,
  payload: id,
});
export const updateSelectedAssignedPhysicians = id => ({
  type: UPDATE_SELECTED_ASSIGNED_PHYSICIANS,
  payload: id,
});
export const updateSelectedQtOrderingPractice = id => ({
  type: UPDATE_SELECTED_QT_ORDERING_PRACTICE,
  payload: id,
});
export const updateSelectedEkgResult = ekgResult => ({
  type: UPDATE_SELECTED_EKG_RESULT,
  payload: ekgResult,
});
export const updateSelectedDates = ({ startDate, endDate }) => ({
  type: UPDATE_SELECTED_DATES,
  payload: {
    startDate,
    endDate,
  },
});
export const updateSelectedBpmValues = ({ startValue, endValue }) => ({
  type: UPDATE_SELECTED_BPM_VALUES,
  payload: {
    startValue,
    endValue,
  },
})
// For updating the filtered QTCF values
export const updateSelectedQtcfValues = ({ startValue, endValue }) => ({
  type: UPDATE_SELECTED_QTCF_VALUES,
  payload: {
    startValue,
    endValue,
  },
})
export const updateSelectedIntrComment = (value) => ({
  type: UPDATE_SELECTED_INTR_COMMENT,
  payload: {
    value,
  },
})
export const updateSelectedPatientText = (value) => ({
  type: UPDATE_SELECTED_PATIENT_TEXT,
  payload: {
    value,
  },
})
export const updateSelectedConfirmedCurrentMonth = date => ({
  type: UPDATE_SELECTED_CONFIRMED_CURRENT_MONTH,
  payload: date,
});
export const updateSelectedEkgs = selected => ({
  type: UPDATE_SELECTED_EKGS,
  payload: selected,
});

export const resetFilters = () => ({
  type: RESET_FILTERS,
});
export const updateSorts = (sortBy, sortDirection) => ({
  type: UPDATE_SORTS,
  payload: {
    sortBy,
    sortDirection,
  },
});
export const resetSorts = () => ({
  type: RESET_SORTS,
});
export const updateSelectedPopover = popover => ({
  type: UPDATE_SELECTED_POPOVER,
  payload: popover,
});
export const dataRequest = () => ({
  type: DATA_REQUEST,
});
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
});
export const dataFailure = () => ({
  type: DATA_FAILURE,
});

export const updateEKGReviewStackNextToken = (token, params) => ({
  type: UPDATE_STACK_NEXT_TOKEN,
  payload: {
    token,
    params,
  },
});

export const updateQtEKGReviewStackNextToken = (token, params) => ({
  type: UPDATE_STACK_NEXT_TOKEN,
  payload: {
    token,
    params,
  },
});

function shouldGetEkgsData(ekgStackCounts, ekgs, selectedPageTab) {
  if (selectedPageTab !== EKG_REVIEW_PAGE_TABS.TRIAGE) {
    return true;
  }
  return !(
    ekgs &&
    ekgs.data &&
    ekgStackCounts.data &&
    ekgStackCounts.data.triage
  );
}

export const getEkgReviewData = (forceUpdate = false) => (
  dispatch,
  getState,
) => {
  dispatch(dataRequest());
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);
  const interpretationsDataSource = getDataSource(
    getState(),
    DATASOURCES.INTERPRETATIONS,
  );
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(meDataSource)
  let promises;

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  if (interpretationsDataSource.data && !forceUpdate) {
    // no-op
  } else {
    promises = promises.then(() => {
      const meDataSource2 = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = meDataSource2.data;

      return dispatch(getInterpretations(teams[0].id));
    });
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME);
      const { teams } = me.data;

      const apiCalls = [];
      const ekgs = getDataSource(getState(), DATASOURCES.EKGS);
     if (isServiceProviderEnabled) {
      dispatch(updateQtEKGReviewStackNextToken(null, {}));
      apiCalls.push(dispatch(getEkgStack()));
     } else if (!(ekgs && ekgs.data)) {
      dispatch(updateQtEKGReviewStackNextToken(null, {}));
      apiCalls.push(dispatch(getEkgStack()));
     }

      return Promise.all(apiCalls);
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getEkgReviewData', err);
      dispatch(dataFailure());
    });
};

export const handleOnRefreshClick = () => (dispatch, getState) => {
  dispatch(updateRefreshClicked(true));
  return dispatch(getEkgReviewData(true)).then(() =>
    dispatch(updateRefreshClicked(false)),
  );
};

// On every tab changed or dropdown change this function is called to fetch data from backend - ( backend filtering )
export const getEkgStack = nextStack => (dispatch, getState) => {
  const {
    selectedInboxId,
    selectedConfirmedCurrentMonth,
    stackNextResultsToken,
    selectedPageTab,
  } = getState().qtEkgReview;
  // console.log(selectedInboxId, ' ==> ', selectedPageTab);
  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  return promises.then(() => {
    const me = getDataSource(getState(), DATASOURCES.ME);
    const { teams } = me.data;
    const { id: teamId } = teams[0];

    const memberId = selectedInboxId;
    let getEkgStackApi;

    const confirmedStartDate = moment(selectedConfirmedCurrentMonth)
      .startOf('month')
      .toISOString();
    const confirmedEndDate = moment(selectedConfirmedCurrentMonth)
      .endOf('month')
      .toISOString();
    // console.log("switch")
    switch (selectedPageTab) {
      case CONFIRMED:
        // console.log('API dispatched'," - confirm");
        getEkgStackApi = dispatch(
          getQtEkgReviewStack(teamId, {
            memberId: null,
            confirmed: true,
            confirmedStartDate,
            confirmedEndDate,
          }),
        );
        break;
      case PHYSICIAN:
        // console.log('API dispatched'," - physician");
        getEkgStackApi = dispatch(
          getQtEkgReviewStack(teamId, {
            memberId: memberId,
            confirmed: false,
            nextToken: nextStack ? stackNextResultsToken : null,
          }),
        );
        break;
      case KPSP_PRACTICE_INBOX:
        // console.log('API dispatched'," - physician");
        getEkgStackApi = dispatch(
          getQtEkgReviewStack(teamId, {
            memberId: null,
            confirmed: false,
            nextToken: nextStack ? stackNextResultsToken : null,
            kpspPracticeTeamId: memberId,
          }),
        );
        break;
      case TRIAGE:
        // console.log('API dispatched', " - triage");
        getEkgStackApi = dispatch(
          getQtEkgReviewStack(teamId, {
            memberId: null,
            confirmed: false,
            nextToken: nextStack ? stackNextResultsToken : null,
          }),
        );
        break;
      default:
        // console.log('API dispatched'," - default");
        break;
    }

    return Promise.all([
      getEkgStackApi,
      dispatch(getPhysiciansAndEkgStackCount(teamId)),
      dispatch(getOrderingProvider(teamId)),
    ]);
  });
};

let previousRecordingIdsFiltersAndSorts;
let cacheRecordingIds = [];
export const getRecordingIdsFromDataSource = state => {
  const {
    [DATASOURCES.EKG_STACKS]: ekgStacks,
    [DATASOURCES.EKGS]: ekgs,
  } = state.app.dataSources;
  const {
    selectedInboxId,
    selectedPatientId,
    selectedPhysicianId,
    selectedPhysicians,
    selectedAssignedPhysicians,
    selectedQtOrderingPractice,
    selectedEkgResult,
    selectedStartDate,
    selectedEndDate,
    selectedBpmStartValue,
    selectedBpmEndValue,
    selectedQtcfStartValue,
    selectedQtcfEndValue,
    selectedIntrText,
    selectedPatientText,
    selectedConfirmedCurrentMonth,
    sortBy,
    sortDirection,
    dataIsFetching,
  } = state.qtEkgReview;

  const filtersAndSorts = {
    ekgsIsFetching: ekgs && ekgs.isFetching,
    ekgStacksIsFetching:
      ekgStacks &&
      ekgStacks[selectedInboxId] &&
      ekgStacks[selectedInboxId].isFetching,
    dataIsFetching,
    selectedInboxId,
    selectedPatientId,
    selectedPhysicians,
    selectedAssignedPhysicians,
    selectedQtOrderingPractice,
    selectedPhysicianId,
    selectedEkgResult,
    selectedStartDate,
    selectedEndDate,
    selectedBpmStartValue,
    selectedBpmEndValue,
    selectedQtcfStartValue,
    selectedIntrText,
    selectedPatientText,
    selectedQtcfEndValue,
    selectedConfirmedCurrentMonth,
    sortBy,
    sortDirection,
  };

  let recordingIds = [];
  let recordingByIds = {};
  const isQtConfirmedDate = selectedInboxId === CONFIRMED;
  const isConfirmedDate = false;

  if (
    ekgs &&
    ekgs.data &&
    ekgStacks &&
    ekgStacks.data &&
    ekgStacks.data.stacks[selectedInboxId]
  ) {
    recordingIds = [
      ...ekgStacks.data.stacks[selectedInboxId].sortedByTimestamp,
    ];
    recordingByIds = ekgs.data.byId;

    if (!isEqual(previousRecordingIdsFiltersAndSorts, filtersAndSorts)) {
      recordingIds = filterEkgRecordingIds(
        filtersAndSorts,
        recordingIds,
        recordingByIds,
        isConfirmedDate,
        isQtConfirmedDate,
      );
      recordingIds = sortEkgRecordingIds(
        filtersAndSorts,
        recordingIds,
        recordingByIds,
      );

      cacheRecordingIds = recordingIds;
    }

    previousRecordingIdsFiltersAndSorts = filtersAndSorts;
  }

  if (
    previousRecordingIdsFiltersAndSorts &&
    previousRecordingIdsFiltersAndSorts.selectedInboxId !==
      filtersAndSorts.selectedInboxId
  ) {
    cacheRecordingIds = [];
  }
  return cacheRecordingIds;
};

export const handleOnSortClick = columnHeader => (dispatch, getState) => {
  const { sortBy, sortDirection } = getState().qtEkgReview;

  if (sortBy === columnHeader) {
    const nextSortDirection = getNextSortDirection(sortDirection);
    dispatch(updateSorts(sortBy, nextSortDirection));
  } else {
    const nextSortDirection = getNextSortDirection();
    dispatch(updateSorts(columnHeader, nextSortDirection));
  }
};

export const handleOnFilterButtonClick = columnHeader => (
  dispatch,
  getState,
) => {
  const { selectedPopover } = getState().qtEkgReview;

  if (selectedPopover === columnHeader) {
    dispatch(updateSelectedPopover(null));
  } else {
    dispatch(updateSelectedPopover(columnHeader));
  }
};

export const handleOnEKGNextClick = () => (dispatch, getState) =>
  dispatch(getEkgStack(true))
    .then(() => dispatch(dataSuccess()))
    .catch(err => dispatch(dataFailure()));

export const handleOnRowClick = ({ index, rowData }) => (
  dispatch,
  getState,
) => {
  const { selectedInboxId } = getState().qtEkgReview;

  const recordingIds = getRecordingIdsFromDataSource(getState());

  dispatch(
    handleOnEkgRecordingNavClick(false, {
      recordingId: rowData.id,
      inboxId: selectedInboxId,
      recordingIds,
    }),
  );
  dispatch(updateSelectedIndex(index));
  dispatch(handleOnSelectionClick({}));
};

export const handleOnPhysicianInboxChange = inboxId => (dispatch, getState) => {
  dispatch(dataRequest());
  dispatch(resetFilters());
  dispatch(resetSorts());
  dispatch(updateSelectedInboxId(inboxId));
  dispatch(updateEKGReviewStackNextToken(null, {}));

  return dispatch(getEkgStack())
    .then(() => dispatch(dataSuccess()))
    .catch(err => dispatch(dataFailure()));
};

export const handleOnProviderInboxChange = inboxId => (dispatch, getState) => {
  dispatch(dataRequest());
  dispatch(resetFilters());
  dispatch(resetSorts());
  dispatch(updateSelectedInboxId(inboxId));
  dispatch(updateEKGReviewStackNextToken(null, {}));

  return dispatch(getEkgStack())
    .then(() => dispatch(dataSuccess()))
    .catch(err => dispatch(dataFailure()));
};

export const handleOnFilterChange = (columnHeader, data) => (
  dispatch,
  getState,
) => {
  switch (columnHeader) {
  case EKG_TABLE_COLUMN_HEADERS.RECORDED_AT:
    dispatch(updateSelectedDates(data))
    break
  case EKG_TABLE_COLUMN_HEADERS.PATIENT:
    dispatch(updateSelectedPatientId(data))
    dispatch(updateSelectedPopover(null))
    break
  case EKG_TABLE_COLUMN_HEADERS.ORDERING_PHYSICIAN:
    dispatch(updateSelectedPhysicians(data))
    break
  case EKG_TABLE_COLUMN_HEADERS.ANALYSIS:
    dispatch(updateSelectedEkgResult(data))
    break
  case EKG_TABLE_COLUMN_HEADERS.ANALYSIS_BY:
    dispatch(updateSelectedPhysicianId(data))
    dispatch(updateSelectedPopover(null))
    break
  case EKG_TABLE_COLUMN_HEADERS.BPM:
    dispatch(updateSelectedBpmValues({
      startValue: data[0],
      endValue: data[1],
    }))
    break
  // For handling the QTCF filter
  case EKG_TABLE_COLUMN_HEADERS.QTCF_VALUE:
    dispatch(updateSelectedQtcfValues({
      startValue: data[0],
      endValue: data[1],
    }))
    break
  case EKG_TABLE_COLUMN_HEADERS.INTERPRETATION_TEXT:
    dispatch(updateSelectedIntrComment(data))
    break
  case EKG_TABLE_COLUMN_HEADERS.QT_PATIENT:
    dispatch(updateSelectedPatientText(data));
    break
  case EKG_TABLE_COLUMN_HEADERS.ASSIGNED_CARDIOLOGIST:
    dispatch(updateSelectedAssignedPhysicians(data));
    break
  case EKG_TABLE_COLUMN_HEADERS.QT_ORDERING_PRACTICE:
    dispatch(updateSelectedQtOrderingPractice(data));
    break
  default:
    break
  }
};

export const handleOnSelectionClick = selected => (dispatch, getState) => {
  const ids = getSelectedList(selected);
  dispatch(updateSelectedEkgs(selected));

  if (ids.length === 0) {
    dispatch(updateBulkActionComplete(false));
  }
};

export const handleOnBulkAction = (bulkActionType, data) => (
  dispatch,
  getState,
) => {
  dispatch(dataRequest());

  const { selectedEkgs, selectedPageTab } = getState().qtEkgReview;

  const selectedIds = getSelectedList(selectedEkgs);

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let successMessage;
  let promises;

  // ensure we have team id
  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  switch (bulkActionType) {
    case TABLE_BULK_ACTIONS.MARK_AS_EXPORT:
      promises = promises.then(() => {
        const me = getDataSource(getState(), DATASOURCES.ME);

        const { teams } = me.data;

        successMessage =
          selectedIds.length === 1
            ? `${selectedIds.length} ECG has been exported. The file will be sent to your email once ready.`
            : `${selectedIds.length} ECGs have been exported. The files will be sent to your email once ready.`;

        return dispatch(postEkgsEmailExport(teams[0].id, selectedIds));
      });
      break;
    default:
      break;
  }

  dispatch(updateBulkActionIsFetching(true));
  return (
    promises
      .then(() => {
        window.setTimeout(() => {
          dispatch(handleOnSelectionClick({}));
        }, 3000);
        dispatch(updateBulkActionIsFetching(false));
        dispatch(updateBulkActionSuccessMessage(successMessage));
        dispatch(closeModal());
        return dispatch(updateBulkActionComplete(true));
      })
      // .then(() => dispatch(updateSelectedEkgs({})))
      .then(() => dispatch(dataSuccess()))
      .catch(err => dispatch(dataFailure()))
  );
};

export const handleOnTabClick = tab => (dispatch, getState) => {
  dispatch(dataRequest());
  dispatch(updateQtEKGReviewStackNextToken(null, {}));

  const meDataSource = getDataSource(getState(), DATASOURCES.ME);

  let promises;

  if (meDataSource.data) {
    promises = Promise.resolve();
  } else {
    promises = dispatch(getMe());
  }

  promises = promises.then(() => {
    const me = getDataSource(getState(), DATASOURCES.ME);

    dispatch(resetPage(tab, me.data.profile.id));
  });

  return promises
    .then(() => dispatch(getEkgStack()))
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log(err);
      dispatch(dataFailure());
    });
};

export const handleOnNavClick = (
  resetData = true,
  handleRouting = false,
  data = {
    inboxId: undefined,
  },
) => (dispatch, getState) => {
  const { inboxId } = data;

  let tab;
  switch (inboxId) {
    case CONFIRMED:
      tab = EKG_REVIEW_PAGE_TABS.CONFIRMED;
      break;
    default:
      tab = EKG_REVIEW_PAGE_TABS.TRIAGE;
      break;
  }

  let promises = Promise.resolve();
  if (handleRouting) {
    promises = promises.then(() => history.push(ROUTES.QT_EKG_REVIEW));
  }

  if (resetData) {
    dispatch(dataRequest());
    dispatch(updateQtEKGReviewStackNextToken(null, {}));
    promises = promises
      .then(() => dispatch(resetPage(tab, inboxId)))
      .then(() => dispatch(getEkgStack()))
      .then(() => dispatch(dataSuccess()))
      .catch(err => dispatch(dataFailure()));
  }

  return promises;
};
//  when ever backend filters are applied this function refreshes the page to the new data
const resetPage = (tab, inboxId) => (dispatch, getState) => {
  const physicianId =
    tab === EKG_REVIEW_PAGE_TABS.PHYSICIAN ||
    tab === EKG_REVIEW_PAGE_TABS.KPSP_PRACTICE_INBOX
      ? inboxId
      : undefined;
  dispatch(updateSelectedPageTab(tab));
  dispatch(updateSelectedIndex(-1));
  dispatch(updateSelectedPopover(null));
  dispatch(resetFilters());
  dispatch(resetSorts());

  switch (tab) {
    case EKG_REVIEW_PAGE_TABS.TRIAGE:
      dispatch(updateSelectedInboxId(TRIAGE));
      break;
    case EKG_REVIEW_PAGE_TABS.PHYSICIAN:
      dispatch(updateSelectedInboxId(physicianId));
      break;
    case EKG_REVIEW_PAGE_TABS.KPSP_PRACTICE_INBOX:
      dispatch(updateSelectedInboxId(physicianId));
      break;
    case EKG_REVIEW_PAGE_TABS.CONFIRMED:
      dispatch(updateSelectedInboxId(CONFIRMED));
      dispatch(updateSelectedDatesForConfirmedMonth());
      dispatch(
        updateSorts(
          EKG_TABLE_COLUMN_HEADERS.QT_CONFIRMED_AT,
          sorts.sortDirection,
        ),
      );
      break;
    default:
      break;
  }

  dispatch(updateBulkActionIsFetching(false));
  dispatch(updateBulkActionComplete(false));
  dispatch(updateSelectedEkgs({}));
};

export const handleOnConfirmedMonthClick = (direction = 0) => (
  dispatch,
  getState,
) =>
  Promise.resolve()
    .then(() => {
      const { selectedConfirmedCurrentMonth } = getState().qtEkgReview;

      let newMonth = selectedConfirmedCurrentMonth;

      if (direction <= -1) {
        newMonth = moment(selectedConfirmedCurrentMonth)
          .subtract(1, 'month')
          .startOf('month')
          .toDate();
      } else if (direction >= 1) {
        newMonth = moment(selectedConfirmedCurrentMonth)
          .add(1, 'month')
          .startOf('month')
          .toDate();
      }

      dispatch(updateSelectedConfirmedCurrentMonth(newMonth));
      dispatch(updateSelectedIndex(-1));
      dispatch(updateSelectedDatesForConfirmedMonth());
      dispatch(updateBulkActionIsFetching(false));
      dispatch(updateBulkActionComplete(false));
      dispatch(updateSelectedEkgs({}));
    })
    .then(() => dispatch(handleOnRefreshClick()))

export const updateSelectedDatesForConfirmedMonth = () => (dispatch, getState) => {
  const {
    selectedConfirmedCurrentMonth,
  } = getState().qtEkgReview

  const confirmedStartDate = moment(selectedConfirmedCurrentMonth).startOf('month').toDate()
  const confirmedEndDate = moment(selectedConfirmedCurrentMonth).endOf('month').toDate()

  dispatch(updateSelectedDates({ startDate: confirmedStartDate, endDate: confirmedEndDate }))
}


const filters = Object.assign({}, {
  selectedPatientId: ALL_PATIENTS_OPTION.id,
  selectedPhysicianId: ALL_PHYSICIANS_OPTION.id,
  selectedEkgResult: [],
  selectedStartDate: KARDIA_PRO_START_DATE,
  selectedEndDate: moment().endOf('day').toDate(),
  selectedBpmStartValue: MIN_BPM_VALUE,
  selectedBpmEndValue: MAX_BPM_VALUE,
  selectedQtcfStartValue: MIN_QTCF_VALUE,
  selectedQtcfEndValue: MAX_QTCF_VALUE,
  selectedIntrText:'',
  selectedPatientText:'',
  selectedConfirmedCurrentMonth: moment().startOf('month').toDate(),
  selectedEkgs: {},
  selectedPhysicians: [],
  selectedAssignedPhysicians: [],
  selectedQtOrderingPractice: [],
})
const sorts = Object.assign({}, {
  sortBy: EKG_TABLE_COLUMN_HEADERS.RECORDED_AT,
  sortDirection: SORT_TYPES.ASC,
})
const initialState = {
  ...cloneDeep(filters),
  ...cloneDeep(sorts),
  bulkActionIsFetching: false,
  bulkActionComplete: false,
  bulkActionSuccessMessage: null,
  refreshClicked: false,
  selectedIndex: -1,
  selectedInboxId: EKG_REVIEW_PAGE_TABS.TRIAGE,
  selectedPageTab: EKG_REVIEW_PAGE_TABS.TRIAGE,
  selectedPopover: null,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_BULK_ACTION_IS_FETCHING]: (state, action) => ({
    ...state,
    bulkActionIsFetching: action.payload,
  }),
  [UPDATE_BULK_ACTION_COMPLETE]: (state, action) => ({
    ...state,
    bulkActionComplete: action.payload,
  }),
  [UPDATE_BULK_ACTION_SUCCESS_MESSAGE]: (state, action) => ({
    ...state,
    bulkActionSuccessMessage: action.payload,
  }),
  [UPDATE_REFRESH_CLICKED]: (state, action) => ({
    ...state,
    refreshClicked: action.payload,
  }),
  [UPDATE_SELECTED_PAGE_TAB]: (state, action) => ({
    ...state,
    selectedPageTab: action.payload,
  }),
  [UPDATE_SELECTED_INDEX]: (state, action) => ({
    ...state,
    selectedIndex: action.payload,
  }),
  [UPDATE_SELECTED_INBOX_ID]: (state, action) => ({
    ...state,
    selectedInboxId: action.payload,
  }),
  [UPDATE_SELECTED_PATIENT_ID]: (state, action) => ({
    ...state,
    selectedPatientId: action.payload,
  }),
  [UPDATE_SELECTED_PHYSICIAN_ID]: (state, action) => ({
    ...state,
    selectedPhysicianId: action.payload,
  }),
  [UPDATE_SELECTED_PHYSICIANS]: (state, action) => ({
    ...state,
    selectedPhysicians: action.payload,
  }),
  [UPDATE_SELECTED_ASSIGNED_PHYSICIANS]: (state, action) => ({
    ...state,
    selectedAssignedPhysicians: action.payload,
  }),
  [UPDATE_SELECTED_QT_ORDERING_PRACTICE]: (state, action) => ({
    ...state,
    selectedQtOrderingPractice: action.payload,
  }),
  [UPDATE_SELECTED_EKG_RESULT]: (state, action) => ({
    ...state,
    selectedEkgResult: action.payload,
  }),
  [UPDATE_SELECTED_DATES]: (state, action) => ({
    ...state,
    selectedStartDate: action.payload.startDate,
    selectedEndDate: action.payload.endDate,
  }),
  [UPDATE_SELECTED_BPM_VALUES]: (state, action) => ({
    ...state,
    selectedBpmStartValue: action.payload.startValue,
    selectedBpmEndValue: action.payload.endValue,
  }),
  // Reducer for QTCF filter in EKG table
  [UPDATE_SELECTED_QTCF_VALUES]: (state, action) => ({
    ...state,
    selectedQtcfStartValue: action.payload.startValue,
    selectedQtcfEndValue: action.payload.endValue,
  }),
  [UPDATE_SELECTED_INTR_COMMENT]: (state, action) => ({
    ...state,
    selectedIntrText: action.payload.value,
  }),
  [UPDATE_SELECTED_PATIENT_TEXT]: (state, action) => ({
    ...state,
    selectedPatientText: action.payload.value,
  }),
  [UPDATE_SELECTED_CONFIRMED_CURRENT_MONTH]: (state, action) => ({
    ...state,
    selectedConfirmedCurrentMonth: action.payload,
  }),
  [UPDATE_SELECTED_EKGS]: (state, action) => ({
    ...state,
    selectedEkgs: action.payload,
  }),
  [RESET_FILTERS]: (state, action) => ({
    ...state,
    ...filters,
  }),
  [UPDATE_SORTS]: (state, action) => ({
    ...state,
    sortBy: action.payload.sortBy,
    sortDirection: action.payload.sortDirection,
  }),
  [RESET_SORTS]: (state, action) => ({
    ...state,
    ...sorts,
  }),
  [UPDATE_SELECTED_POPOVER]: (state, action) => ({
    ...state,
    selectedPopover: action.payload,
  }),
  [DATA_REQUEST]: (state, action) => ({
    ...state,
    dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state,
    dataIsFetching: false,
    dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state,
    dataIsFetching: false,
    dataLastUpdated: new Date(),
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
  [UPDATE_STACK_NEXT_TOKEN]: (state, action) => ({
    ...state,
    stackNextResultsToken: action.payload,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function qtEkgReviewReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/legacy/pages/QtEkgReview/module.js